import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { IMAGES } from "../../data/store";

const CHAPTERS = [
  {
    n: "I",
    title: "Herencia",
    lead: "De rancho en rancho",
    body: "El Navegante Wester nació de la costumbre. Botas, sombreros y cinturones que se pasan de padres a hijos, con el olor a cuero y el sonido de la espuela.",
  },
  {
    n: "II",
    title: "Talabartería",
    lead: "Hecho a mano",
    body: "Trabajamos con talabarteros que labran monturas, cabezadas y cinchas como se hacía hace un siglo. Cada pieza es firma. Cada pieza dura.",
  },
  {
    n: "III",
    title: "Comunidad",
    lead: "En el corazón de Hollister",
    body: "Somos el punto de reunión de rancheros, charros y familias que aman el estilo western. Vestimos rodeos, jaripeos, bodas y días de mercado.",
  },
];

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-15%", "15%"]);

  return (
    <section
      id="nosotros"
      ref={ref}
      data-testid="about-section"
      className="relative py-28 md:py-40 overflow-hidden"
    >
      <motion.div style={{ y: bgY }} className="absolute inset-0 z-0 scale-110">
        <img
          src={IMAGES.desert}
          alt=""
          className="h-full w-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-[#0A0908]/85" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mb-20"
        >
          <p className="text-xs md:text-sm uppercase tracking-[0.4em] text-[#A66E38] mb-4 flex items-center gap-3">
            <span className="h-px w-8 bg-[#A66E38]" /> Manifiesto
          </p>
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl font-black leading-[0.95] text-[#F5F0E6]">
            Tres capítulos de{" "}
            <span className="italic text-[#C89B3C]">tradición vaquera</span>.
          </h2>
        </motion.div>

        <div className="space-y-16 md:space-y-24">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.n}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`chapter-${c.n}`}
              className="grid grid-cols-12 gap-6 md:gap-10 items-start border-t border-white/10 pt-10 md:pt-14"
            >
              <div className="col-span-12 md:col-span-3">
                <p className="font-serif text-6xl md:text-8xl font-black text-[#C89B3C] leading-none">
                  {c.n}
                </p>
                <p className="mt-3 text-xs uppercase tracking-[0.4em] text-[#8A7D71]">
                  Capítulo
                </p>
              </div>
              <div className="col-span-12 md:col-span-4">
                <p className="text-xs uppercase tracking-[0.35em] text-[#A66E38] mb-3">
                  {c.lead}
                </p>
                <h3 className="font-serif text-3xl md:text-5xl font-bold text-[#F5F0E6] leading-tight">
                  {c.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-5">
                <p className="text-base md:text-lg font-light text-[#B8A99A] leading-relaxed">
                  {c.body}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
